import { MutationHookOptions, useMutation } from '@apollo/client';

import { CREATE_GROUP } from './mutations';

export const useCreateGroup = (options?: MutationHookOptions) => useMutation(CREATE_GROUP, options);
